/**
 * format IBAN before send it to BE (e.g remove spaces)
 * @param {string} value
 * keywords: iban, format
 */

const forceBEFormat = (value: string): string => value.replace(/(\s+)/g, '');

export default forceBEFormat;
